"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateText = exports.sleep = exports.removeDatabasePrefix = exports.parseBoolean = exports.isBuffer = exports.isArrayBufferView = exports.isDataView = exports.isArrayBuffer = exports.isFunction = exports.isString = exports.isBoolean = exports.isSymbol = exports.isObject = exports.isNumber = exports.isUndefined = exports.isNull = void 0;
const isNull = (value) => value === null;
exports.isNull = isNull;
const isUndefined = (value) => typeof value === 'undefined' || value === undefined;
exports.isUndefined = isUndefined;
const isNumber = (value) => typeof value === 'number';
exports.isNumber = isNumber;
// eslint-disable-next-line @typescript-eslint/ban-types
const isObject = (value) => Object.prototype.toString.call(value) === '[object Object]' || typeof value === 'object';
exports.isObject = isObject;
const isSymbol = (value) => typeof value === 'symbol';
exports.isSymbol = isSymbol;
const isBoolean = (value) => typeof value === 'boolean';
exports.isBoolean = isBoolean;
const isString = (value) => typeof value === 'string';
exports.isString = isString;
// eslint-disable-next-line @typescript-eslint/ban-types
const isFunction = (value) => typeof value === 'function';
exports.isFunction = isFunction;
const isArrayBuffer = (value) => value instanceof ArrayBuffer;
exports.isArrayBuffer = isArrayBuffer;
const isDataView = (value) => value instanceof DataView;
exports.isDataView = isDataView;
const isArrayBufferView = (value) => ArrayBuffer.isView(value) && !(0, exports.isDataView)(value);
exports.isArrayBufferView = isArrayBufferView;
const isBuffer = (value) => value instanceof Buffer;
exports.isBuffer = isBuffer;
const parseBoolean = (value) => {
    switch (String(value || '')
        .toString()
        .toLowerCase()) {
        case 'true':
        case '1':
        case 'on':
        case 'yes':
            return true;
        default:
            return false;
    }
};
exports.parseBoolean = parseBoolean;
const removeDatabasePrefix = (value) => {
    return String(value).replace(/^\w+_/, '');
};
exports.removeDatabasePrefix = removeDatabasePrefix;
const sleep = (milliseconds) => new Promise((res) => setTimeout(res, milliseconds));
exports.sleep = sleep;
const truncateText = (text, length, showEllipsis = true) => {
    if (text.length > length) {
        return `${text.substring(0, length)}${showEllipsis ? '...' : ''}`;
    }
    return text;
};
exports.truncateText = truncateText;
//# sourceMappingURL=helpers.js.map